import React from 'react'
import {ErrorMessage, Field, FormikErrors} from 'formik'

interface Props {
  containerClassName?: string
  label?: string
  name: string
  type?: string
  placeholder?: string
  onChange: (e: React.ChangeEvent<any>) => void
  className?: string
  errors?: FormikErrors<any>
  touched?: any
  labelClassName?: string
  required?: boolean
  checkBoxText?: string
  value?: string | number | boolean
  defaultValue?: any
  checked?: boolean
  disabled?: boolean
}

const FormRadio = React.memo((props: Props) => {
  const {
    containerClassName,
    label,
    name,
    type,
    onChange,
    className,
    errors,
    touched,
    labelClassName,
    required,
    checkBoxText,
    value,
    defaultValue,
    checked,
    disabled,
    ...rest
  } = props

  return (
    <div className={containerClassName ?? 'col-lg-6 '}>
      <div className='form-check form-check-custom form-check-solid me-10'>
        <Field
          name={name}
          label={label}
          type={type || 'radio'}
          value={value}
          checked={checked}
          defaultValue={defaultValue}
          className={className || 'form-check-input h-25px w-25px'}
          data-cy={`${name}-${value}-radio-field`}
          disabled={disabled}
          onChange={onChange}
          {...rest}
        />
        <label className='form-check-label' htmlFor='flexRadio25'>
          {checkBoxText}
        </label>
        {/* <div className='fv-plugins-message-container text-danger fw-bolder small text-start mt-1'>
          <ErrorMessage name={name} component='div' className='field-error-message' />
        </div> */}
      </div>
    </div>
  )
})

export default FormRadio
